import { styled } from 'baseui'

export const StyledContainer = styled('div', () => ({
  width: '100%',
  padding: '1rem',
  paddingBottom: '0.4rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}))

export const StyledTitleWrapped = styled('h3', ({ $theme }) => ({
  flexGrow: 1,
  margin: 0,
  color: $theme.colors.primary,
  ...$theme.typography.HeadingXSmall,
  fontSize: '1.5rem',
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
}))

export const HeaderContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
})

export const StyledTitle = styled('h3', () => ({
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  fontWeight: '600',
  fontSize: '1.125rem',
  lineHeight: '160%',
  color: '#343535',
}))

export const ChangeUserContainer = styled('div', () => ({
  width: '100%',
  display: 'flex',
}))
